import angular from 'angular';

export default class ContentHeaderController {
    /** @ngInject */
    constructor($mdPanel) {
        this.$mdPanel = $mdPanel;
    }

    $onInit() {
        if (!this.stateTitle) {
            this.stateTitle = 'Specify State Title';
        }
    }

    showHelpMenu(ev) {
        this.isActive = true;

        const mdPanel = this.$mdPanel;

        const panelPosition = mdPanel.newPanelPosition()
            .relativeTo(ev.target)
            .addPanelPosition(mdPanel.xPosition.ALIGN_END, mdPanel.yPosition.BELOW);

        const config = {
            attachTo: angular.element(document.querySelector('.application-container')),
            controller: () => {},
            controllerAs: '$ctrl',
            template: '<dt-help-menu md-panel-ref="$ctrl.mdPanelRef"></dt-help-menu>',
            targetEvent: ev,
            panelClass: 'md-panel--arrow-top',
            position: panelPosition,
            openFrom: ev,
            clickOutsideToClose: true,
            escapeToClose: true,
            focusOnOpen: true,
            onRemoving: () => {
                this.isActive = false;
            }
        };

        mdPanel.open(config);
    }
}



// WEBPACK FOOTER //
// ./app/common/content-header/content-header.controller.js